// Section for import npm components ------------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import { MansionReviewContext } from '@providers/MansionDetail/MansionReview/MansionReviewProvider';
import ScoreRating from '@components/MansionDetail/MansionReview/ScoreRating';
import ReviewList from '@components/MansionDetail/MansionReview/ReviewList';

// Section for type definition -----------------------------------------------------------------------------------------
type ReviewCategoryContainerProps = {
  category: string;
};

export default function ReviewCategoryContainer(props: ReviewCategoryContainerProps) {
  const { category } = props;
  const mansionReviewContext = useContext(MansionReviewContext);
  // @ts-ignore
  const { mansionReview } = mansionReviewContext;

  return (
    <Box className="w-full md:flex md:gap-x-[10%] md:pt-10 md:border-t md:border-gray-02">
      <Box className="md:w-[26%] max-md:mb-6">
        <ScoreRating
          title={mansionReview.category[category].score.title}
          score={mansionReview.category[category].score.score}
          countViewers={mansionReview.category[category].reviewCount}
          isReview={mansionReview.category[category].isReview}
          categoryName={category}
        />
      </Box>
      <Box className="md:w-[64%]">
        <Box>
          <ReviewList category={category} />
        </Box>
      </Box>
    </Box>
  );
}
